import { render, staticRenderFns } from "./PointsRedemption.vue?vue&type=template&id=c6e95ac8&scoped=true"
import script from "./PointsRedemption.vue?vue&type=script&lang=js"
export * from "./PointsRedemption.vue?vue&type=script&lang=js"
import style0 from "./PointsRedemption.vue?vue&type=style&index=0&id=c6e95ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e95ac8",
  null
  
)

export default component.exports